import React from "react";

const ProgressBar = ({
  label,
  value,
  maxValue,
  percentage,
  color,
  icon,
  formatValue,
}) => {
  const pct =
    percentage != null
      ? percentage
      : maxValue
        ? Math.min((value / maxValue) * 100, 100)
        : 0;

  const displayValue = formatValue ? formatValue(value) : value;

  return (
    <div className="space-y-1.5">
      {/* Top row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center min-w-0">
          {icon && <i className={`${icon} text-gray-400 mr-2`} />}
          <span className="font-medium text-gray-900 dark:text-white text-sm truncate">
            {label}
          </span>
        </div>
        <span className="text-sm text-gray-600 dark:text-gray-400 flex-shrink-0 ml-2">
          {displayValue}
        </span>
      </div>

      {/* Bar */}
      <div className="w-full bg-gray-200 dark:bg-gray-700/50 rounded-full h-2">
        <div
          className={`${color || "bg-primary-600"} h-2 rounded-full transition-all duration-500`}
          style={{ width: `${Math.max(0, Math.min(pct, 100))}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
